import { renderContent } from "./content-renderer.js";
import { resolveContentConfig } from "../shared/config.js";

import type { FormVueContentOptions } from "../shared/schema-types.js";

const FormVue = {
  render(target: string | HTMLElement, options: FormVueContentOptions): void {
    const el = typeof target === "string" ? document.querySelector<HTMLElement>(target) : target;
    if (!el) { console.error(`FormVue: target element not found: ${target}`); return; }
    if (!options.formId) { console.error("FormVue: formId is required"); return; }
    if (!options.id) { console.error("FormVue: id is required"); return; }
    if (el.shadowRoot) this.destroy(el);

    const config = resolveContentConfig(options);
    renderContent(el, config);
  },

  destroy(target: string | HTMLElement): void {
    const el = typeof target === "string" ? document.querySelector<HTMLElement>(target) : target;
    if (!el) return;
    (el as any).__fvUnmount?.();
    delete (el as any).__fvUnmount;
    if (el.shadowRoot) el.shadowRoot.innerHTML = "";
  },

  update(target: string | HTMLElement, options: FormVueContentOptions): void {
    this.destroy(target);
    this.render(target, options);
  },
};

export { FormVue };
export type { FormVueContentOptions } from "../shared/schema-types.js";
export type { ContentConfig } from "../shared/types.js";
